import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AccountApp from "./AccountApp";
import AdminApp from "./AdminApp";
import { AuthRoot } from "./auth";
import "./account.css";
import "./styles.css";

const isAdmin = window.location.pathname.startsWith("/admin");

function CustomerRouter() {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const updatePathname = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", updatePathname);
    return () => window.removeEventListener("popstate", updatePathname);
  }, []);

  return pathname.startsWith("/account") ? <AccountApp /> : <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isAdmin ? <AdminApp /> : <AuthRoot><CustomerRouter /></AuthRoot>}
  </StrictMode>,
);
